<template>
  <div class="browse-search">
    <div class="search-form">
      <div class="input-group">
        <input
          class="form"
          type="text"
          :placeholder="$t('searchPlaceholder')"
          v-model="searchQuery"
          @input="debounceInputDeleteEvent"
          @delete="debounceInputDeleteEvent"
        >
      </div>
    </div>
    <div v-if="filterBrowseContents" class="filtered-contents">
      <div class="small-link">
        <div @click="clearQuery">{{ $t('clearQuery') }}</div>
        <div v-if="found.length" @click="collapse">{{ $t('collapseAllButtonLabel') }}</div>
      </div>
      <div dir="rtl" v-if="found.length">
        <li v-for="(row, index) in found" :key="`row-${index}`">
          {{ row.label }}
          <div class="search-result-row">
            <BrowseRow
              :row="row"
              :work="work"
              @selected="selection => $emit('selected', selection)"
            />
          </div>
        </li>
      </div>
      <div v-else>
        <small>{{ $t('noSearchResults') }}</small>
      </div>
    </div>
  </div>
</template>

<script>
  import debounce from 'lodash.debounce';
  import BrowseRow from './BrowseRow.vue';
  import {
    COLLAPSE_ALL_BROWSE_CONTENT,
    SET_BROWSE_FILTER_STATUS,
  } from '../../constants';

  export default {
    components: {
      BrowseRow,
    },
    props: ['work'],
    data() {
      return {
        searchQuery: '',
        found: [],
      };
    },
    computed: {
      filterBrowseContents() {
        return this.$store.state.filterBrowseContents;
      },
    },
    methods: {
      // eslint-disable-next-line func-names
      debounceInputDeleteEvent: debounce(function () {
        if (this.searchQuery) {
          this.$store.dispatch(SET_BROWSE_FILTER_STATUS, { status: true });
          const found = [];
          const workContentData = this.$store.state.browseContentData[this.work.urn];
          (workContentData).forEach((edge) => {
            edge.node.sectionCollations.forEach((row) => {
              this.filterData(row, found, this.searchQuery);
            });
          });
          const sortedFound = this.sortResults(found);
          this.found = sortedFound;
        } else if (this.filterBrowseContents) {
          this.clearQuery();
        }
      }, 500),
      filterData(row, container, searchQuery) {
        if (row.textContent.includes(searchQuery)) {
          container.push(row);
        } else {
          row.children.forEach((child) => {
            this.filterData(child, container, this.searchQuery);
          });
        }
      },
      sortResults: results => (
        results.sort((a, b) => a.depth > b.depth)
      ),
      collapse() {
        this.$store.dispatch(COLLAPSE_ALL_BROWSE_CONTENT, { status: true });
      },
      clearQuery() {
        this.$store.dispatch(SET_BROWSE_FILTER_STATUS, { status: false });
        this.searchQuery = '';
      },
    },
  };
</script>

<style lang="scss">
  @import './Browse';
  @import '../../variables';
  #app[data-locale="ar"] .browse-search {
    direction: rtl;
    font-family: $ar-font-family;
    font-size: $ar-default-font-size;
  }
  .search-result-row {
    margin-bottom: 1.0em;
  }
</style>
